import React from 'react';

export default ({ color = '#C4C6CD' }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_31818_1981)">
      <path
        d="M10 3.75V2.5H8.75V1.875C8.75 1.70924 8.68415 1.55027 8.56694 1.43306C8.44973 1.31585 8.29076 1.25 8.125 1.25H7.5V0H6.25V1.25H3.75V0H2.5V1.25H1.875C1.70924 1.25 1.55027 1.31585 1.43306 1.43306C1.31585 1.55027 1.25 1.70924 1.25 1.875V2.5H0V3.75H1.25V6.25H0V7.5H1.25V8.125C1.25 8.29076 1.31585 8.44973 1.43306 8.56694C1.55027 8.68415 1.70924 8.75 1.875 8.75H2.5V10H3.75V8.75H6.25V10H7.5V8.75H8.125C8.29076 8.75 8.44973 8.68415 8.56694 8.56694C8.68415 8.44973 8.75 8.29076 8.75 8.125V7.5H10V6.25H8.75V3.75H10ZM7.5 7.5H2.5V2.5H7.5V7.5Z"
        fill="#2822B7"
      />
      <path d="M6.25 3.75H3.75V6.25H6.25V3.75Z" fill="#2822B7" />
    </g>
    <defs>
      <clipPath id="clip0_31818_1981">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
